/**
 * Asynchronously loads the component for LoginPage
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
